<script>
  export default {
    props: {
      value: {
        type: Number,
        default: 1,
      },
      list: {
        type: Array,
        default: () => {
          return [
            {
              title: '標題',
              description: ''
            }
          ]
        },
      }
    },
    methods: {
      onClickStep(step) {
        this.$emit('change', step)
      }
    }
  }
</script>
<template>
  <el-steps
    class="isStyleBase"
    :active="value"
    align-center
  >
    <el-step
      v-for="(stepItem, index) in list"
      :key="index"
      :title="stepItem.title"
      :description="stepItem.description"
      @click.native="onClickStep(stepItem.value)"
    ></el-step>
  </el-steps>
</template>
